module.exports = __webpack_public_path__ + "img/img-form-menu.9a5f96af.png";